import GelHackToggleButton from "../gel/GelHackToggleButton";
import QuestionInputSelect from "./QuestionInputSelect";
import GelHackButton from "../gel/GelHackButton";
import common from "../../common";

export default class QuestionInputSelectTime extends QuestionInputSelect {
    constructor(question, view) {
        super(question, view);

    }

    showCorrectAnswer() {
        //empty, removed feature
        /*
        let correct;
        for (let i = 0; i < this._buttons.length; ++i) {
            correct = this._buttons[i];
            if (correct.value.value[0] === this._question.answer.value[0] && correct.value.value[1] === this._question.answer.value[1]) {
                correct.tint = 0x00AA00;
                break;
            }
        }
        */
    }

    createOptionButton(value) {
        const a = P3.assets;

        const buttonStates = new P3.ButtonStates();
        buttonStates.normal = a.texture("ui_drop_in_area");
        buttonStates.normalAlt = a.texture("ui_drop_in_area_selected");
        buttonStates.over = a.texture("ui_drop_in_area_highlight");
        buttonStates.over = a.texture("ui_drop_in_area_selected");

        const button = !PIXI.utils.isMobile.any ?
            new GelHackToggleButton(buttonStates) :
            new P3.ToggleButton(buttonStates);

        button.value = value;
        button.animate = false;
        button.animateIcon = false;
        button.tint = common.config.debug && button.value === this._question.answer ? 0x00AA00 : 0xFFFFFF;

        const str = (this._question.part === 2 || this._question.timeType === 'time') ? button.value.toString() : button.value.toTime();
        //const fontSize = str.length < 5 ? 40 : 20;

        button.label = new PIXI.Text(str, {
            fontSize: this._fontSize,
            fontFamily: "Arial",
            fontWeight: "bold",
            fill: 0x0,
            wordWrap: true,
            wordWrapWidth: 125
        });
        button.label.position.set(0, 0);
        button.label.anchor.set(0.5, 0.5);
        button.label.resolution = 2;
        button.animation.addChild(button.label);
        return button;
    }
}